var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.6667H20V6.66667H25V4H20V0H16.6667V4H11.6667V6.66667H16.6667V10.6667ZM10 22.6667C8.16667 22.6667 6.68333 23.8667 6.68333 25.3333C6.68333 26.8 8.16667 28 10 28C11.8333 28 13.3333 26.8 13.3333 25.3333C13.3333 23.8667 11.8333 22.6667 10 22.6667ZM26.6667 22.6667C24.8333 22.6667 23.35 23.8667 23.35 25.3333C23.35 26.8 24.8333 28 26.6667 28C28.5 28 30 26.8 30 25.3333C30 23.8667 28.5 22.6667 26.6667 22.6667ZM11.8333 16H24.25C25.5 16 26.6 15.4533 27.1667 14.6267L33.6 5.28L30.7 4L24.25 13.3333H12.55L5.45 1.33333H0V4H3.33333L9.33333 14.12L7.08333 17.3733C5.86667 19.16 7.46667 21.3333 10 21.3333H30V18.6667H10L11.8333 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCart);
export default __webpack_public_path__ + "static/media/white-cart.a7d527d3389f3dc0e56c9387e4852962.svg";
export { ForwardRef as ReactComponent };